export default __webpack_public_path__ + "static/media/img (2).3219d52b.jpg";